/**
 * Enum for stock browser sku table fields
 * @readonly
 * @enum {Array}
 */
export const STOCK_BROWSER_SKU_TABLE_FIELDS = Object.freeze([
	{
		key: 'image',
		label: '',
		class: 'image-col',
		cellClass: 'image-cel',
	},
	{
		key: 'sku',
		label: 'SKU',
		class: 'sku-col',
		cellClass: 'sku-cel',
	},
	{
		key: 'product_name',
		label: 'Product Name',
		class: 'product-name-col',
		cellClass: 'product-name-cel',
	},
	{
		key: 'brand',
		label: 'Brand',
		class: 'brand-col',
		cellClass: 'brand-cel',
	},
	{
		key: 'available_stock',
		label: 'Available stock',
		class: 'available-stock-col',
		cellClass: 'available-stock-cel',
	},
	{
		key: 'online_stock',
		label: 'Online stock',
		class: 'online-stock-col',
		cellClass: 'online-stock-cel',
	},
	{
		key: 'offline_stock',
		label: 'Offline stock',
		class: 'offline-stock-col',
		cellClass: 'offline-stock-cel',
	},
	{
		key: 'total_stock',
		label: 'Total stock',
		class: 'total-stock-col',
		cellClass: 'total-stock-cel',
	},
	{
		key: 'reserved',
		label: 'Reserved',
		class: 'reserved-col',
		cellClass: 'reserved-cel',
	},
	{
		key: 'committed',
		label: 'Commited',
		class: 'committed-col',
		cellClass: 'committed-cel',
	},
	{
		key: 'online_a',
		label: 'Fast Stock Total',
		class: 'group-col th-mw-80',
		cellClass: 'group-cel',
	},
	{
		key: 'online_b',
		label: 'Normal Stock Total',
		class: 'group-col th-mw-80',
		cellClass: 'group-cel',
	},
	{
		key: 'online_a_remaining',
		label: 'Fast Stock Remaining',
		class: 'group-col th-mw-150',
		cellClass: 'group-a-remaining-cel',
	},
	{
		key: 'online_b_remaining',
		label: 'Normal Stock Remaining',
		class: 'group-col th-mw-150',
		cellClass: 'group-b-remaining-cel',
	},
	{
		key: 'status',
		label: 'Status',
		class: 'status-col',
		cellClass: 'status-cel',
	},
	{
		key: 'type',
		label: 'Type',
		class: 'type-col',
		cellClass: 'type-cel',
	},
	{
		key: 'eolStatus',
		label: 'EOL status',
		class: 'type-col',
		cellClass: 'type-cel',
	},
	{
		key: 'last_synced',
		label: 'Last synced',
		class: 'last-synced-col',
		cellClass: 'last-synced-cel',
	},
]);

/**
 * Enum for stock browser sku table fields
 * @readonly
 * @enum {Array}
 */
export const STOCK_BROWSER_SKU_DETAIL_TABLE_FIELDS = Object.freeze([
	{
		key: 'branch_id',
		label: 'Branch id',
		class: 'branch-id-col',
		cellClass: 'branch-id-cel',
	},
	{
		key: 'branch_name',
		label: 'Branch Name',
		class: 'branch-name-col',
		cellClass: 'branch-name-cel',
	},
	{
		key: 'online_stock_quantity',
		label: 'Online stock qty',
		class: 'online-stock-col',
		cellClass: 'online-stock-cel',
	},
	{
		key: 'offline_stock_quantity',
		label: 'Offline stock qty',
		class: 'offline-stock-col',
		cellClass: 'offline-stock-cel',
	},
	{
		key: 'total_stock_quantity',
		label: 'Total stock qty',
		class: 'total-stock-quantity-col',
		cellClass: 'total-stock-quantity-cel',
	},
	{
		key: 'location',
		label: 'Location',
		class: 'location-col',
		cellClass: 'location-cel',
	},
]);

/**
 * Enum for stock browser branch table fields
 * @readonly
 * @enum {Array}
 */
export const STOCK_BROWSER_BRANCH_TABLE_FIELDS = Object.freeze([
	{
		key: 'branch_id',
		label: 'Branch id',
		class: 'branch-id-col',
		cellClass: 'branch-id-cel',
	},
	{
		key: 'branch_name',
		label: 'Branch name',
		class: 'branch-name-col',
		cellClass: 'branch-name-cel',
	},
	{
		key: 'total_brand',
		label: 'Total Brand',
		class: 'total-brand-col',
		cellClass: 'total-brand-cel',
	},
	{
		key: 'total_sku',
		label: 'Total SKU',
		class: 'total-sku-col',
		cellClass: 'total-sku-cel',
	},
	{
		key: 'total_stock',
		label: 'Total Stock',
		class: 'total-stock-col',
		cellClass: 'total-stock-cel',
	},
	{
		key: 'online_percentage',
		label: 'Online Stock%',
		class: 'online-percentage-col',
		cellClass: 'online-percentage-cel',
	},
	{
		key: 'offline_percentage',
		label: 'Offline Stock%',
		class: 'offline-stock-col',
		cellClass: 'offline-stock-cel',
	},
	{
		key: 'location',
		label: 'Location',
		class: 'location-col th-mw-150',
		cellClass: 'location-cel',
	},
	{
		key: 'last_synced',
		label: 'Last synced',
		class: 'last-synced-col th-mw-150',
		cellClass: 'last-synced-cel',
	},
]);

/**
 * Enum for stock browser branch detail table fields
 * @readonly
 * @enum {Array}
 */
export const STOCK_BROWSER_BRANCH_DETAIL_TABLE_FIELDS = Object.freeze([
	{
		key: 'image',
		label: '',
		class: 'image-col',
		cellClass: 'image-cel',
	},
	{
		key: 'sku',
		label: 'SKU',
		class: 'sku-col',
		cellClass: 'sku-cel',
	},
	{
		key: 'product_name',
		label: 'Product Name',
		class: 'product-name-col',
		cellClass: 'product-name-cel',
	},
	{
		key: 'brand',
		label: 'Brand',
		class: 'brand-col',
		cellClass: 'brand-cel',
	},
	{
		key: 'category',
		label: 'Category',
		class: 'category-col',
		cellClass: 'category-cel',
	},
	{
		key: 'stock',
		label: 'Stock',
		class: 'stock-col',
		cellClass: 'stock-cel',
	},
	{
		key: 'status',
		label: 'Status',
		class: 'status-col',
		cellClass: 'status-cel',
	},
	{
		key: 'type',
		label: 'Type',
		class: 'type-col',
		cellClass: 'type-cel',
	},
	{
		key: 'last_synced',
		label: 'Last synced',
		class: 'last-synced-col',
		cellClass: 'last-synced-cel',
	},
]);

export const CHANNEL_ORDER_QTY = {
	TOTAL: 'channel_order_total',
};

export const STOCK_BROWSER_TAB = {
	BRANCH: 'branch',
	SKU: 'sku',
};
